import { mapGetters } from 'vuex';
import constants from '@/constants';

export default {

  computed: {
    ...mapGetters(['getFeatureSwitch', 'getFeatureSchedule']),

    isAutoClockOutEnabled() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.AUTO_CLOCK_OUT);
    },
  },

  methods: {
    hasScheduledTimePast() {
      const scheduledTimeInfo = this.getFeatureSchedule(constants.FEATURE_SWITCHES_TITLES.AUTO_CLOCK_OUT);
      const now = new Date();

      const scheduledTime = this.getScheduledTimeFromInfo(scheduledTimeInfo);
      console.log(now);
      console.log(scheduledTime);
      return now.getTime() > scheduledTime.getTime();
    },

    getScheduledTimeFromInfo(scheduledTimeInfo) {
      const date = new Date();
      date.setHours(scheduledTimeInfo.hours, scheduledTimeInfo.minutes, 0);
      return date;
    },

    showAutoClockOutWarningDialog(confirmHandler, cancelHandler) {
      this.showAppConfirmDialog({
        message: this.$t('dialogs.confirm.autoClockOutAlreadyTriggered'),
        color: constants.AppColors.WARN,
        confirmText: this.$t('actions.confirm'),
        confirmHandler,
        cancelText: this.$t('actions.cancel'),
        cancelHandler,
      });
    },
  },
};
